"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseManager = void 0;
class BaseManager {
    constructor() {
        this.managedSystems = [];
        this._systemListeners = { add: [], remove: [] };
    }
    update() {
        this.onUpdate();
        return this.managedSystems.map(s => s.update());
    }
    clear() {
        this.onClear();
        const systems = [...this.managedSystems];
        systems.forEach(this.removeSystem.bind(this));
    }
    emit(eventname, system) {
        if (eventname === 'add') {
            this.managedSystems.push(system);
        }
        for (let i = 0; i < this._systemListeners[eventname].length; i++) {
            this._systemListeners[eventname][i](system);
        }
    }
    addSystem(system) {
        for (let i = 0; i < this._systemListeners['add'].length; i++) {
            this._systemListeners['add'][i](system);
        }
        this.managedSystems.push(system);
    }
    removeSystem(system) {
        system.onClear();
        for (let i = 0; i < this._systemListeners['remove'].length; i++) {
            this._systemListeners['remove'][i](system);
        }
        const idx = this.managedSystems.indexOf(system);
        idx > -1 && this.managedSystems.splice(idx, 1);
    }
    on(eventname, cb) {
        this._systemListeners[eventname].push(cb);
    }
    off(eventname, cb) {
        const idx = this._systemListeners[eventname].indexOf(cb);
        idx > -1 && this._systemListeners[eventname].splice(idx, 1);
    }
}
exports.BaseManager = BaseManager;
//# sourceMappingURL=module.js.map